import { asyncRouterMap, constantRouterMap } from '@/router/index';
import { isRouteFeatureEnabled } from '@/config/features';

//判断是否有权限访问该菜单
function hasPermission(menus, route) {
  if (!isRouteFeatureEnabled(route)) {
    return false;
  }
  if (route.name) {
    let currMenu = getMenu(route.name, menus);
    if (currMenu!=null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== '') {
        route.meta.title = currMenu.title;
      }
      if (currMenu.icon != null && currMenu.title !== '') {
        route.meta.icon = currMenu.icon;
      }
      if(currMenu.hidden!=null){
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort;
      }
      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort=-1;
        return true;
      } else {
        return false;
      }
    }
  } else if (route.hidden !== undefined && route.hidden === true) {
    route.sort = -1;
    return true;
  }
  return false;
}

//根据路由名称获取菜单
function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name===menu.name) {
      return menu;
    }
  }
  return null;
}

//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if(router.children && router.children.length > 0){
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//降序比较函数
function compare(p){
  return function(m,n){
    let a = m[p];
    let b = n[p];
    return b - a;
  }
}

function cloneRoute(route) {
  const clonedRoute = {
    ...route,
    meta: route.meta ? { ...route.meta } : route.meta
  }
  if (route.children && route.children.length > 0) {
    clonedRoute.children = route.children.map(child => cloneRoute(child))
  }
  return clonedRoute
}

function filterAsyncRoutes(routes, menus) {
  return routes.reduce((result, route) => {
    const currentRoute = cloneRoute(route)
    const selfAccessible = hasPermission(menus, currentRoute)
    const childRoutes = currentRoute.children && currentRoute.children.length > 0 && (!currentRoute.name || selfAccessible)
      ? filterAsyncRoutes(currentRoute.children, menus)
      : []

    if (childRoutes.length > 0) {
      currentRoute.children = childRoutes
      if (currentRoute.sort == null) {
        currentRoute.sort = Math.max.apply(null, childRoutes.map(child => child.sort || 0))
      }
      result.push(currentRoute)
      return result
    }

    if (selfAccessible) {
      result.push(currentRoute)
    }
    return result
  }, [])
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { menus } = data;
        // 保留存在可访问子菜单的父级容器路由，避免“只分配子菜单时整组路由被裁掉”。
        const accessedRouters = filterAsyncRoutes(asyncRouterMap, menus);
        //对菜单进行排序
        sortRouters(accessedRouters);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      })
    }
  }
};

export default permission;




// WEBPACK FOOTER //
// ./src/store/modules/permission.js